// extracted by mini-css-extract-plugin
export default {"row":"StarRating_row__DoJWX","starBtn":"StarRating_starBtn__6NIoN","star":"StarRating_star__AJYWv","starStatic":"StarRating_starStatic__Q9fWq"};